import { combineReducers } from 'redux';
import {
  fetchRequirementsAction,
  fetchRequirementsSuccessAction,
} from '../actions/requirements';
import { createReducer } from 'redux-create-reducer';

const requirementReducer = field => {
  return createReducer([], {
    [fetchRequirementsSuccessAction]: (state, action) => {
      return action.payload[field].filter(i => !i.deleted);
    },
  });
};

const securityEpis = requirementReducer('securityEpis');
const inventoryToPlan = requirementReducer('inventoryToPlan');
const workers = requirementReducer('workers');

const isFetching = createReducer(false, {
  [fetchRequirementsAction]: (state, action) => {
    return true;
  },
  [fetchRequirementsSuccessAction]: (state, action) => {
    return false;
  },
});

const requirements = combineReducers({
  isFetching,
  securityEpis,
  inventoryToPlan,
  workers,
});

export default requirements;

export const getSecurityEpis = state => state.requirements.securityEpis;
export const getInventoryToPlan = state => state.requirements.inventoryToPlan;
export const getWorkers = state => state.requirements.workers;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step3/reducers/requirements.js